const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function toDate(value: number | null | undefined): Date | null {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return null;
  }
  const millis = value < 1e12 ? value * 1000 : value;
  return new Date(millis);
}

export function formatDateTime(value: number | null | undefined): string {
  const date = toDate(value);
  if (!date) {
    return "—";
  }
  return date.toLocaleString(undefined, {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    second: "2-digit",
    year: "numeric",
  });
}

export function formatRelativeTime(value: number | null | undefined): string {
  const date = toDate(value);
  if (!date) {
    return "never";
  }
  const now = Date.now();
  const delta = now - date.getTime();

  if (delta < 0) {
    return "in the future";
  }
  if (delta < MINUTE) {
    return `${Math.max(0, Math.floor(delta / SECOND))}s ago`;
  }
  if (delta < HOUR) {
    return `${Math.floor(delta / MINUTE)}m ago`;
  }
  if (delta < DAY) {
    return `${Math.floor(delta / HOUR)}h ago`;
  }
  return `${Math.floor(delta / DAY)}d ago`;
}

export function formatDurationMs(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return "—";
  }

  const abs = Math.abs(value);
  if (abs < SECOND) {
    return `${Math.round(value)} ms`;
  }
  if (abs < MINUTE) {
    const seconds = value / SECOND;
    return `${seconds.toFixed(abs < 10 * SECOND ? 2 : 1)}s`;
  }
  if (abs < HOUR) {
    const minutes = value / MINUTE;
    return `${minutes.toFixed(abs < 10 * MINUTE ? 2 : 1)}m`;
  }
  if (abs < DAY) {
    const hours = value / HOUR;
    return `${hours.toFixed(abs < 10 * HOUR ? 2 : 1)}h`;
  }
  const days = value / DAY;
  return `${days.toFixed(abs < 10 * DAY ? 2 : 1)}d`;
}
